export default __webpack_public_path__ + "static/media/05.02c66a74.jpg";